import colorPresets from './colorPresets';

const gradient = (name) => colorPresets.find((p) => p.name === name).gradient;

// Suggestions shown in the first-run onboarding modal. Names are intentionally
// generic verbs ("Exercise", "Read") — the modal lets the user rename inline
// before adding ("Climbing", "Read 20 pages").
const STARTER_HABITS = [
  { name: 'Exercise', color: gradient('Forest'),  weekly_goal: 2 },
  { name: 'Read',     color: gradient('Ocean'),   weekly_goal: 2 },
  { name: 'Meditate', color: gradient('Nebula'),  weekly_goal: 1 },
  { name: 'Drink water', color: gradient('Arctic'), weekly_goal: 4 },
  { name: 'Journal',  color: gradient('Bloom'),   weekly_goal: 1 },
];

export default STARTER_HABITS;
